import CustomButton from "components/CustomButton";
import { OutlinedButton } from "components/CustomButton";
import { DangerButton } from "components/CustomButton";
import CustomIcon from "components/CustomIcon";
import ToggleSwitch from "components/toggleSwitch/ToggleSwitch";
import { Link } from "react-router-dom";


const PredictionCampaign = ({ campaign, onEdit, onDelete, onResult, toggleStatus, disabledToggle = false }) => {

  return (

    <div className="custom-card flex items-start space-x-4  hover:shadow-md ">
      <div className="w-full flex flex-col">
        <div
          className="flex justify-between mb-1 text-sm sm:text-md flex-col-reverse items-start sm:flex-row sm:items-center">
          <Link
            key={campaign?.id}
            to={{
              pathname: `/predictions/${campaign.id}`,
            }}
          >
            <div className="text-lg hover:cursor-pointer link hover:opacity-80"> {campaign?.title}</div>
          </Link>
          <div className="flex space-x-4 justify-end">
            <ToggleSwitch
              isChecked={campaign.active}
              isDisabled={disabledToggle}
              onChange={toggleStatus}
            />
            <OutlinedButton
              onClick={onResult}
              isIconButton={true}
            >
              Result
              </OutlinedButton>
            <CustomButton
              onClick={onEdit}
              isIconButton={true}
            >
              <CustomIcon icon="edit" />
            </CustomButton>
            <DangerButton
              onClick={onDelete}

              isIconButton={true}
            >
              <CustomIcon icon="delete" />
            </DangerButton>
          </div>
        </div>
      </div>

    </div>
  )
}

export default PredictionCampaign;
